module.exports = __webpack_public_path__ + "img/24-7-service-.2ca206c5.png";